export default Object.freeze({
	ADMIN: 'Admin'
});